import { createEffect, createStore } from 'effector'
import api from '../../Auth/api'

export const $mainTable = createStore<any>(null)

//@ts-ignore
export const getMainTableFx = createEffect(async (data) => {
  const response = api.post(`paid-service/search`, data)
  return response
})

$mainTable.on(getMainTableFx.done, (state, { result }) => {
  return {
    //@ts-ignore
    ...state,
    data: result.data.data
  }
})
//@ts-ignore
$mainTable.on(getMainTableFx.fail, (state, { error }) => {
  return {
    error: 'error'
  }
})
